import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { setEmail, setUserPhone } from "Store/appStore/action";
import { Form, message } from "antd";
import { PageLayout, PageLayoutHeader } from "Components/PageLayout";
import HotKeysModal from "Components/HotKeysModal";
import { withRouter } from "react-router-dom";
import Notice from "Components/Notice";
import Ajax from "Pub/js/ajax";
import InfoForm from "./InfoForm";
import PasswordEdit from "./PasswordEdit";
import PersonPhoneEdit from "./PersonPhoneEdit";
import PhoneEdit from "./PhoneEdit";
import EmailEdit from "./EmailEdit";
import RSAUtils from "Pub/js/security.js";
import { setStore, getStore } from "Pub/js/storageUtils";
import { getMulti } from "Pub/js/getMulti";
import { langCheck } from "Pub/js/utils.js";
import "./index.less";
import platform from "Pub/js/platform";
const { NCDiv } = platform.base;
const Cryptograph = platform.Cryptograph;
class SwitchInfo extends Component {
    constructor(props) {
        super(props);
    }
    
    render() {
        let { personelInfo={} } = this.props;
         
        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 8 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 16 },
            },
        };
        switch (this.props.infoType) {
            // 密码修改
            case "0":
                return (
                    <PasswordEdit
                        layout={formItemLayout}
                        formObj={this.props.formObj}
                        json={this.props.json}
                        exponent={this.props.exponent}
                        modulus={this.props.modulus}
                        pageRef={this.props.pageRef}
                    />
                );
            // 手机修改
            case "1":
                return (
                    <PhoneEdit
                        layout={formItemLayout}
                        formObj={this.props.formObj}
                        json={this.props.json}
                        exponent={this.props.exponent}
                        modulus={this.props.modulus}
                        infoType ={this.props.infoType}
                        mobile = {personelInfo.mobile} //人员手机号
                        setValWhenGetCaptcha={val=>this.props.setValWhenGetCaptcha(val)}
                        pageRef={this.props.pageRef}
                    />
                );
            // 邮箱修改
            case "2":
            case "3":
                return (
                    <EmailEdit
                        layout={formItemLayout}
                        formObj={this.props.formObj}
                        json={this.props.json}
                        exponent={this.props.exponent}
                        modulus={this.props.modulus}
                        infoType ={this.props.infoType}
                        email = {personelInfo.email} //人员邮箱
                        setValWhenGetCaptcha={val=>this.props.setValWhenGetCaptcha(val)}
                        pageRef={this.props.pageRef}
                    />
                );
            case "4":
                return (
                    <PersonPhoneEdit
                        layout={formItemLayout}
                        formObj={this.props.formObj}
                        json={this.props.json}
                        exponent={this.props.exponent}
                        modulus={this.props.modulus}
                        setValWhenGetCaptcha={val=>this.props.setValWhenGetCaptcha(val)}
                        pageRef={this.props.pageRef}
                    />
                );
            default:
                return "";
        }
    }
}
class UserInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            editData: {},
            infoType: "", //用户'2' 人员'3'
            modalTitle: "",
            visible: false,
            picture: "",
            phone: "",
            email: "",
            valWhenGetCaptcha:'', //点击获取验证码时传入的email或者手机号(放在this里也行？)
            exponent: "",
            modulus: "",
            json: {},
            personelInfo: null, //人员信息 {name email mobile}
        };
    }
    /**
     * 弹框标题选择
     */
    switchTitle = key => {
        let { json } = this.state;
        switch (key) {
            case "0":
                return langCheck("UserInfo-000015", "pages", json); /* 国际化处理： 密码修改*/
            case "1":
            case "4":
                return langCheck("UserInfo-000016", "pages", json); /* 国际化处理： 手机修改*/
            case "2":
            case "3":
                return langCheck("UserInfo-000017", "pages", json); /* 国际化处理： 电子邮箱修改*/

            default:
                break;
        }
    };
    showModal = infoType => {
        let modalTitle = this.switchTitle(infoType);
        this.setState({
            visible: true,
            infoType,
            modalTitle,
        });
    };
    setValWhenGetCaptcha = val=>{
        this.setState({ valWhenGetCaptcha:val }); 
    }
    
    handleOk = type => {
        // 表单提交前进行校验
        const { valWhenGetCaptcha, json } = this.state;
        const { form } = this.props;

        if((type=='3'||type=='2')&& form.getFieldValue('email')!== valWhenGetCaptcha ) {
            message.error(langCheck('UserInfo-000058', 'pages', json)); /* 国际化处理：提交时的邮箱和获取验证码时的邮箱不一致*/
            return;
        }
        if((type=='1'||type=='4') && form.getFieldValue('phone')!== valWhenGetCaptcha ) {
            message.error(langCheck('UserInfo-000059', 'pages', json)); /* 国际化处理：提交时的手机号和获取验证码时的手机号不一致*/
            return;
        }

        form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                let allValue = this.props.form.getFieldsValue();
                this.saveInfo(type, allValue);
            }
        });
    };
    /**
     * 用户信息保存
     * @param {String} key "0" - 密码修改 "1" - 手机修改 "2" - 电子邮件修改
     * @param {Object} data 需要保存的数据
     */
    saveInfo = (key, data) => {
        let { json, personelInfo = {} } = this.state;
        // let RSAkey = RSAUtils.getKeyPair(this.state.exponent, "", this.state.modulus);
        const cipher = new Cryptograph({});
        let RSAkey = cipher.getAsyncPublicKey();

        const resetAjaxFlag = () => {
            this.ajaxFlag = null;
        }
        this.ajaxFlag = true;
        switch (key) {
            //修改密码
            case "0":
                Ajax({
                    toastContainer: this.pageRef,
                    url: `/nccloud/platform/appregister/resetuserpwd.do`,
                    data: {
                        // oldPassword: RSAUtils.encryptedString(RSAkey, data.pw),
                        oldPassword: cipher.asymmetricEncrypt(data.pw, RSAkey),
                        // newPassword: RSAUtils.encryptedString(RSAkey, data.newpw),
                        newPassword: cipher.asymmetricEncrypt(data.newpw, RSAkey),
                    },
                    info: {
                        name: langCheck("UserInfo-000000", "pages", json) /* 国际化处理： 账户设置*/,
                        action: langCheck("UserInfo-000018", "pages", json), /* 国际化处理： 密码设置*/
                    },
                    success: ({ data: { data } }) => {
                        resetAjaxFlag();
                        Notice({ status: "success", msg: data.msg });
                        this.handleCancel();
                    },
                    error: resetAjaxFlag,
                });
                break;
            //更新人员手机号
            case "1":
                Ajax({
                    toastContainer: this.pageRef,
                    url: `/nccloud/platform/email/updatepsnmobile.do`,
                    data: {
                        // password: RSAUtils.encryptedString(RSAkey, data.pw),
                        password: cipher.asymmetricEncrypt(data.pw, RSAkey),
                        captcha: data.captcha,
                        mobile: data.phone || personelInfo.mobile,
                    },
                    info: {
                        name: langCheck("UserInfo-000000", "pages", json) /* 国际化处理： 账户设置*/,
                        action: langCheck("UserInfo-000016", "pages", json), /* 国际化处理： 更换手机号码*/
                    },
                    success: ({ data: { data } }) => {
                        resetAjaxFlag();
                        if (data.status) {
                            Notice({ status: "success", msg: data.msg });
                            this.getPersonelInfo();
                            this.handleCancel();
                        } else {
                            Notice({ status: "typeError", msg: data.msg, container: this.pageRef });
                        }
                    },
                    error: resetAjaxFlag,
                });
                break;
            //更新人员邮箱
            case "3":
                Ajax({
                    toastContainer: this.pageRef,
                    url: `/nccloud/platform/userinfo/updatepsninfo.do`,
                    data: {
                        email: data.email || personelInfo.email,
                        // password: RSAUtils.encryptedString(RSAkey, data.pw),
                        password: cipher.asymmetricEncrypt(data.pw, RSAkey),
                        captcha: data.captcha,
                    },
                    info: {
                        name: langCheck("UserInfo-000000", "pages", json) /* 国际化处理： 账户设置*/,
                        action: langCheck("UserInfo-000052", "pages", json), /* 国际化处理： 更新人员信息*/
                    },
                    success: ({ data: { data } }) => {
                        resetAjaxFlag();
                        if (data.status) {
                            Notice({ status: "success", msg: data.msg });
                            this.getPersonelInfo();
                            this.handleCancel();
                        } else {
                            Notice({ status: "typeError", msg: data.msg, container: this.pageRef });
                        }
                    },
                    error: resetAjaxFlag,
                });
                break;
            //修改绑定邮箱
            case "2":
                Ajax({
                    toastContainer: this.pageRef,
                    url: `/nccloud/platform/email/updatebind.do`,
                    data: {
                        email: data.email,
                        // password: RSAUtils.encryptedString(RSAkey, data.pw),
                        password: cipher.asymmetricEncrypt(data.pw, RSAkey),
                        captcha: data.captcha,
                    },
                    loading: true,
                    info: {
                        name: langCheck("UserInfo-000019", "pages", json) /* 国际化处理： 更新用户邮箱*/,
                        action: langCheck("UserInfo-000019", "pages", json), /* 国际化处理： 更新用户邮箱*/
                    },
                    success: ({ data: { data: resData } }) => {
                        resetAjaxFlag();
                        if (resData.status) {
                            this.props.setEmail(data.email);
                            Notice({ status: "success", msg: resData.msg });
                            let infoData = getStore("STOREFORINFODATA", true);
                            infoData.email = data.email;
                            setStore("STOREFORINFODATA", infoData, true);
                            this.handleCancel();
                        } else {
                            Notice({ status: "typeError", msg: resData.msg, container: this.pageRef });
                        }
                    },
                    error: resetAjaxFlag,
                });
                break;
            //更新用户手机号
            case "4":
                Ajax({
                    toastContainer: this.pageRef,
                    url: `/nccloud/platform/telphone/updateBindTelphone.do`,
                    data: {
                        password: RSAUtils.encryptedString(RSAkey, data.pw),
                        captcha: data.captcha,
                        telphone: data.phone,
                    },
                    info: {
                        name: langCheck("UserInfo-000000", "pages", json) /* 国际化处理： 账户设置*/,
                        action: langCheck("UserInfo-000016", "pages", json), /* 国际化处理： 更换手机号码*/
                    },
                    success: ({ data: { data } }) => {
                        resetAjaxFlag();
                        if (data.status) {
                            this.props.setUserPhone(data.user.telphone);
                            Notice({ status: "success", msg: data.msg });
                            let infoData = getStore("STOREFORINFODATA", true);
                            infoData.telphone = data.user.telphone;
                            setStore("STOREFORINFODATA", infoData, true);
                            this.handleCancel();
                        } else {
                            Notice({ status: "typeError", msg: data.msg, container: this.pageRef });
                        }
                    },
                    error: resetAjaxFlag,
                });
                break;
            default:
                break;
        }
    };
    handleCancel = () => {
        this.props.form.resetFields();
        this.setState({ visible: false });
    };
    /**
     * 返回按钮
     */
    handleBackClick = () => {
        // 返回首页
        this.props.history.push(`/`);
    };
    //更新人员信息
    updatepersonelInfo = data => {
        this.setState({ personelInfo: data });
    }
    //查询人员信息
    getPersonelInfo = () => {
        Ajax({
            toastContainer: this.pageRef,
            url: `/nccloud/platform/userinfo/queryuserpsninfo.do`,
            info: {
                name: langCheck(
                    'UserInfo-000000',
                    'pages',
                    this.state.json,
                ) /* 国际化处理： 账户设置*/,
                action: langCheck(
                    'UserInfo-000053',
                    'pages',
                    this.state.json,
                ) /* 国际化处理： 查询人员信息*/,
            },
            sysAppcode: 10228888,
            success: ({ data: { data } }) => {
                this.updatepersonelInfo(data);
            },
        });
    }
    componentDidMount() {
        let callback = json => {
            this.setState({ json: json }, () => {
                /**
                 * 获取加密秘钥
                 */
                Ajax({
                    toastContainer: this.pageRef,
                    url: `/nccloud/platform/appregister/querypublickey.do`,
                    data: {},
                    info: {
                        name: langCheck("UserInfo-000000", "pages", json) /* 国际化处理： 账户设置*/,
                        action: langCheck("UserInfo-000018", "pages", json), /* 国际化处理： 密码设置*/
                    },
                    success: ({ data: { data } }) => {
                        this.setState({
                            exponent: data.exponent,
                            modulus: data.modulus,
                        });
                    },
                });
                this.getPersonelInfo();
            });
        };
        getMulti({
            moduleId: "UserInfo",
            // currentLocale: 'zh-CN',
            domainName: "workbench",
            callback,
        });
    }
    render() {
        let { picture, phone, email, json, infoType, personelInfo } = this.state;
        const fieldidMap = {
            "0": "passwordEdit",
            "2": "emailEdit",
            "4": "personPhoneEdit"
        }
        return (
            <PageLayout
                onRef={ref => this.pageRef = ref}
                className='workbench-userinfo'
                header={
                    <PageLayoutHeader pageback={this.handleBackClick}>
                        <div className='pageLayoutHeaderOwn'>
                            {
                                !this.props.hideBackBtn && <i className='iconfont icon-danjufanhuiicon' onClick={this.handleBackClick} />
                            }
                            <NCDiv fieldid={langCheck("UserInfo-000000", "pages", json)} areaCode={NCDiv.config.Title}>
                                {langCheck("UserInfo-000000", "pages", json) /* 国际化处理： 账户设置*/}
                            </NCDiv>
                        </div>
                    </PageLayoutHeader>
                }>
                <div
                    style={{
                        height: "100%",
                        display: "flex",
                        alignItems: "center",
                    }}>
                    <InfoForm
                        picture={picture}
                        phone={phone}
                        email={email}
                        infoSetting={this.showModal}
                        json={json}
                        personelInfo={personelInfo}
                        updatepersonelInfo={this.updatepersonelInfo}
                        pageRef={this.pageRef}
                    />
                    <HotKeysModal
                        container={this.pageRef}
                        closable={true}
                        maskClosable={false}
                        title={this.state.modalTitle}
                        destroyOnClose={true}
                        mask={true}
                        wrapClassName='vertical-center-modal'
                        visible={this.state.visible}
                        fieldid={fieldidMap[infoType]}
                        onOk={() => {
                            if (this.ajaxFlag) {
                                return;
                            }
                            this.handleOk(this.state.infoType);
                        }}
                        onCancel={this.handleCancel}
                        okText={langCheck("UserInfo-000004", "pages", json)} /* 国际化处理： 确定*/
                        cancelText={langCheck("UserInfo-000005", "pages", json)} /* 国际化处理： 取消*/
                    >
                        <div className='userinfo-modal-content'>
                            <SwitchInfo
                                infoType={this.state.infoType}
                                formObj={this.props.form}
                                personelInfo = {personelInfo}
                                phone={phone}
                                email={email}
                                json={json}
                                exponent={this.state.exponent}
                                modulus={this.state.modulus}
                                setValWhenGetCaptcha={val=>this.setValWhenGetCaptcha(val)}
                                pageRef={this.pageRef}
                            />
                        </div>
                    </HotKeysModal>
                </div>
            </PageLayout>
        );
    }
}
UserInfo.propTypes = {
    setEmail: PropTypes.func.isRequired,
    setUserPhone: PropTypes.func.isRequired,
};
const WrappedUserInfo = Form.create()(UserInfo);
export default withRouter(
    connect(state => ({}), {
        setEmail,
        setUserPhone,
    })(WrappedUserInfo),
);
